import onDeleteReadings from './onDeleteReadings';

export default {
  onDeleteReadings,
};
